import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBell = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2487_5162)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M7.5 3.33325C7.5 2.67021 7.23661 2.03433 6.76777 1.56548C6.29893 1.09664 5.66304 0.833252 5 0.833252C4.33696 0.833252 3.70107 1.09664 3.23223 1.56548C2.76339 2.03433 2.5 2.67021 2.5 3.33325C2.5 6.24992 1.25 7.08325 1.25 7.08325H8.75C8.75 7.08325 7.5 6.24992 7.5 3.33325Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M5.72084 8.75C5.64759 8.87628 5.54244 8.9811 5.41594 9.05397C5.28943 9.12684 5.146 9.16519 5.00001 9.16519C4.85402 9.16519 4.71059 9.12684 4.58408 9.05397C4.45757 8.9811 4.35243 8.87628 4.27917 8.75",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2487_5162",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 10,
			height: 10,
			fill: "white"
		})
	}) })]
});
export default SvgBell;
